import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useBranding, BrandLogo } from "@/context/BrandingContext";
import { ArrowLeft } from "lucide-react";
import { EnquirySection } from "./Landing";

export default function ManagedRecruitment() {
    const branding = useBranding();
    const [cc, setCc] = useState({});
    useEffect(() => {
        api.get("/settings/landing-content").then((r) => setCc(r.data?.content || {})).catch(() => {});
    }, []);
    return (
        <div className="min-h-screen bg-background text-foreground">
            <header className="border-b border-border bg-white">
                <div className="max-w-[1600px] mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
                    <Link to="/" className="flex items-center gap-2" data-testid="mr-brand">
                        <BrandLogo size={28} />
                        <span className="font-display font-black text-lg tracking-tight">{branding.short_name}</span>
                    </Link>
                    <nav className="flex items-center gap-3 text-sm font-medium">
                        <Link to="/" className="hidden sm:inline-flex items-center gap-1 text-muted-foreground hover:text-ikb transition-colors" data-testid="mr-back-home">
                            <ArrowLeft className="w-4 h-4" /> Back to home
                        </Link>
                        <Link to="/login"><Button variant="ghost" className="rounded-none" data-testid="mr-login-btn">Sign in</Button></Link>
                        <Link to="/signup"><Button className="rounded-none bg-ikb hover:bg-[#001f7a] text-white" data-testid="mr-signup-btn">Start hiring →</Button></Link>
                    </nav>
                </div>
            </header>

            {/* Hero strip */}
            <section className="border-b border-border bg-foreground text-background">
                <div className="max-w-[1600px] mx-auto px-4 sm:px-6 py-14 sm:py-20">
                    <div className="text-xs uppercase tracking-widest font-mono text-[#7faaff] mb-3">Managed recruitment</div>
                    <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.05] max-w-3xl">
                        Hire faster with our <span className="text-[#7faaff]">in-house recruiters</span> running your funnel.
                    </h1>
                    <p className="mt-6 text-white/70 text-base sm:text-lg max-w-2xl leading-relaxed">
                        We staff your pipeline — sourcing, screening, scheduling, candidate experience — and you stay
                        in {branding.product_name} to review and approve. Pay per hire. No retainers.
                    </p>
                </div>
            </section>

            <EnquirySection brandingShort={branding.short_name} brandingName={branding.product_name} cc={cc} />

            <footer className="bg-white border-t border-border">
                <div className="max-w-[1600px] mx-auto px-6 py-8 flex items-center justify-between text-xs font-mono text-muted-foreground">
                    <div>© 2026 {branding.short_name} · Built for hiring teams</div>
                    <Link to="/" className="hover:text-ikb">Back to home →</Link>
                </div>
            </footer>
        </div>
    );
}
